import { render } from "./SelectCollectionButton.vue.js?vue&type=template&id=3860ccb4!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollectionButton.vue?vue&type=template&id=3860ccb4"
import script from "./SelectCollectionButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollectionButton.vue?vue&type=script&lang=js"
export * from "./SelectCollectionButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollectionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-story-card/SelectCollectionButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3860ccb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3860ccb4', __exports__)) {
    api.reload('3860ccb4', __exports__)
  }
  
  module.hot.accept("./SelectCollectionButton.vue.js?vue&type=template&id=3860ccb4!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SelectCollectionButton.vue?vue&type=template&id=3860ccb4", () => {
    api.rerender('3860ccb4', render)
  })

}


export default __exports__